import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Desvincular", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Atualizar Categorias", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "ant-row" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = { class: "ant-row" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_11 = { class: "ant-row ss-grade-personalizada-titulo" }
const _hoisted_12 = { class: "ant-col ant-col-xs-1 ant-col-xl-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-23 ant-col-xl-13" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Categoria")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-10" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Conta Contábil Referenciada")
], -1)
const _hoisted_15 = { class: "ant-col ant-col-xs-1 ant-col-xl-1" }
const _hoisted_16 = { class: "ss-margin-campos" }
const _hoisted_17 = { class: "ant-col ant-col-xs-23 ant-col-xl-13" }
const _hoisted_18 = { class: "ss-margin-campos" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-10" }
const _hoisted_20 = { class: "ss-margin-campos" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-21 ant-col-xl-21" }
const _hoisted_24 = { class: "ant-col ant-col-xs-3 ant-col-xl-3 ss-div-botao" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_plano_conta = _resolveComponent("selecionar-plano-conta")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_selecionar_conta_contabil_referenciada = _resolveComponent("selecionar-conta-contabil-referenciada")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 900,
    centered: "",
    "wrap-class-name": "scroll-modal ss-modal-cadastros"
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Vincular Categorias a Contas Contabéis Referenciada ")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.desvincular()))
          }, _hoisted_2),
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.atualizarCategorias()))
          }, _hoisted_4)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_form_item, {
                label: "Empresas",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_empresa, {
                    varias: true,
                    empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                    codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                    "onUpdate:codigosSelecionados": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                  }, null, 8, ["empresasEspecificas", "codigosSelecionados"])
                ]),
                _: 1
              })
            ])
          ], 512), [
            [_vShow, _ctx.telaBase.apresentarEmpresas]
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_a_form_item, {
                label: "Plano de Contas",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_plano_conta, {
                    empresas: _ctx.telaBase.empresasSelecionadas,
                    codigoSelecionado: _ctx.state.codigoPlanoConta,
                    "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.codigoPlanoConta) = $event)),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.buscarCategorias()))
                  }, null, 8, ["empresas", "codigoSelecionado"])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_a_form_item, {
                label: "Pesquisar",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.filtro) = $event)),
                    placeholder: "Digite o número ou nome da categoria que você deseja pesquisar...",
                    onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filtrar()))
                  }, null, 544), [
                    [_vModelText, _ctx.state.filtro]
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_a_checkbox, {
                checked: _ctx.state.todosMarcados,
                "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.todosMarcados) = $event)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.marcarDesmarcarTodos($event)))
              }, null, 8, ["checked"])
            ]),
            _hoisted_13,
            _hoisted_14
          ]),
          _createVNode(_component_a_skeleton, {
            loading: _ctx.telaBase.carregando
          }, {
            default: _withCtx(() => [
              (_ctx.state.categorias.length <= 0)
                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                    key: 0,
                    mensagem: "Nenhuma categoria encontrada"
                  }))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.state.categorias, (categoria, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "ant-row ss-grade-personalizada-linha",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_a_checkbox, {
                            checked: _ctx.state.checks[index],
                            "onUpdate:checked": ($event: any) => ((_ctx.state.checks[index]) = $event)
                          }, null, 8, ["checked", "onUpdate:checked"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", null, _toDisplayString(categoria.numero + ' - ' + categoria.nome), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          ((categoria.codigoContaContabilReferenciada > 0))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(categoria.numeroContaContabilReferenciada + ' - ' + categoria.nomeContaContabilReferenciada), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
            ]),
            _: 1
          }, 8, ["loading"]),
          _withDirectives(_createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_a_form_item, {
                label: "Conta Contábil Referenciada",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_selecionar_conta_contabil_referenciada, {
                    codigoSelecionado: _ctx.state.contaSelecionada,
                    "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.contaSelecionada) = $event)),
                    descricaoSelecionado: _ctx.state.descricaoContaSelecionada,
                    "onUpdate:descricaoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.descricaoContaSelecionada) = $event)),
                    empresas: _ctx.telaBase.empresasSelecionadas
                  }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "empresas"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_a_form_item, {
                label: " ",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-primary ss-botao",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.definir()))
                  }, "Definir")
                ]),
                _: 1
              })
            ])
          ], 512), [
            [_vShow, (_ctx.state.categorias.length > 0)]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
    ]),
    _: 1
  }, 8, ["visible"]))
}